import { NavLink } from 'react-router-dom';

const NAV = [
  { to: '/dashboard', label: 'Dashboard', icon: '◈' },
  { to: '/clients',   label: 'Clienti',   icon: '👤' },
  { to: '/listino',   label: 'Listino',   icon: '⚙' },
  { to: '/preventivi',label: 'Preventivi',icon: '📄' },
  { to: '/impostazioni', label: 'Impostazioni', icon: '⚙' },
];

export default function Sidebar() {
  return (
    <aside className="w-56 shrink-0 border-r border-line bg-panel flex flex-col">
      <div className="px-4 py-4 border-b border-line">
        <h1 className="text-lg font-semibold text-brand-300 tracking-tight">MiniCRM</h1>
      </div>
      <nav className="flex-1 p-2 space-y-0.5">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive
                  ? 'bg-brand-600/20 text-brand-300'
                  : 'text-surface-3 hover:bg-line hover:text-surface'
              }`
            }
          >
            <span className="w-4 text-center">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="px-4 py-3 border-t border-line text-[11px] text-surface-4">
        ArcaneTechPro©
      </div>
    </aside>
  );
}
